/* src/app/order/order-detail/order-detail.component.scss */
.container {
  gap: 30px;
}
.header ion-icon {
  font-size: 35px;
}
.header .title {
  gap: 15px;
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 628px) {
  .header ion-icon {
    font-size: 28px;
    min-width: 28px;
  }
  .header .title {
    font-size: 28px !important;
  }
}
.order-detail-container {
  gap: 30px;
}
.tracking-container {
  padding: 20px;
}
h2 {
  padding: 15px;
  border-radius: 15px;
  background-color: #f6f6f6;
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 639px) {
  h2 {
    font-size: 28px;
  }
}
.modal .data-title {
  font-size: 12px;
  color: gray;
}
.modal .data {
  font-size: 14px;
}
.print-settings {
  color: #292929;
  background: #ffcd00;
  padding: 1px 4px;
  border-radius: 5px;
  margin-right: 1px;
  margin-bottom: 5px;
  text-align: center;
  font-size: 8px;
  vertical-align: bottom;
  font-weight: bold;
}
title {
  display: inline;
}
.caption-pause {
  text-align: center;
}
.caption-pause span {
  font-size: 12px;
  color: gray;
  white-space: pre-wrap;
  font-style: italic;
}
.close-button {
  color: black;
  min-height: 0;
  --border-radius: 0;
}
.close-button::part(native) {
  padding: 0;
}
.close-button ion-icon {
  font-size: 20px;
}
.products-list {
  gap: 15px;
}
.products-list span {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.shipping-info {
  gap: 15px;
}
.shipping-info span {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.type-label {
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 15px;
  border-radius: 15px;
  border: 1px solid #cbcbcb;
}
.type-label ion-icon {
  width: 40px;
  height: 32px;
}
.type-label span {
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.type-label.standard > span > span {
  color: #0c8ce9;
}
.type-label.standard_24 > span > span {
  color: #d59b00;
}
.type-label.urgent > span > span {
  color: #ff007f;
}
.type-label.payment-type {
  border-color: #949494;
}
.type-label.payment-type ion-icon {
  width: 32px;
  height: 32px;
}
.coupon-description {
  color: #949494;
}
.discount {
  color: #43c0f6;
  font-family: "League Spartan";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.invoice-download {
  margin: 0;
  line-height: 0;
  --border-radius: 15px;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.invoice-download::part(native) {
  padding: 14px 18px;
}
.invoice-download ion-icon {
  margin-right: 10px;
}
.box-status {
  border-radius: 20px;
  color: white;
  display: inline-block;
  padding: 5px 12px;
  font-family: "Barlow Semi Condensed";
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  background-color: #f5b200;
}
/*# sourceMappingURL=order-detail.component-JXTWGRDY.css.map */
